import classNames from 'classnames';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { cn } from '../common/utils';
import { createDynamicFilterPreset } from '../filterPreset/store/filterPreset.helper';
import {
  filterPresetDynamic,
  filterPresetSelectedIdentity,
} from '../filterPreset/store/filterPreset.state';
import { ColumnConfig } from './DatasetTable';
import * as Icon from './icons';

export type DatasetTableHeaderPresetIconProps<T extends Object> = {
  tableId: string;
  column: ColumnConfig<T>;
  data: T[];
};

function DatasetTableHeaderPresetIcon<T extends Object>(
  props: DatasetTableHeaderPresetIconProps<T>,
) {
  const { t } = useTranslation('app');
  const [dynamicPreset, setDynamicPreset] = useRecoilState(filterPresetDynamic);
  const setSelectedPresetId = useSetRecoilState(filterPresetSelectedIdentity);

  if (_.isNil(props.column.dynamicPresetConfig)) return null;
  const presetId = `dynamic-preset-${props.tableId}-${props.column.field}`;
  const hasActivePreset = dynamicPreset?.id === presetId;

  function onClick() {
    if (hasActivePreset) {
      setDynamicPreset(null);
      setDynamicPreset(null);
    }
    const preset = createDynamicFilterPreset({
      id: presetId,
      title: t`Table Col:` + props.column.title,
      column: props.column.field as string,
      values: _.map(props.data, row => _.get(row, props.column.field)),
    });
    setDynamicPreset(preset);
    setSelectedPresetId({
      presetId,
    });
  }

  const styleIconButton = classNames(
    'h-8 w-8',
    'fill-current',
    'bg-menu/10 lg:bg-menu/5',
    'hover:bg-menu-active hover:text-menu-active-text',
    hasActivePreset ? 'text-menu-active bg-menu/20' : '',
    'p-1',
    'mx-0.5',
    'rounded-full',
    'cursor-pointer',
  );

  return (
    <div
      data-component="DatasetTableHeaderPresetIcon"
      className={classNames({
        'any-hover-none:opacity-0 any-hover:hover:opacity-100 any-hover:group-hover:opacity-50':
          !hasActivePreset,
      })}
      onClick={onClick}
    >
      <Icon.ShowTable className={cn(styleIconButton)} />
    </div>
  );
}

export default DatasetTableHeaderPresetIcon;
